/**
 * Route for `data-encryption-at-rest-in-transit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DataEncryptionAtRestInTransitPage } from "../features/data-encryption-at-rest-in-transit/DataEncryptionAtRestInTransitPage";

export const dataEncryptionAtRestInTransitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/data-encryption-at-rest-in-transit",
	component: DataEncryptionAtRestInTransitPage,
});

export default dataEncryptionAtRestInTransitRoute;
